import React from 'react';
import classNames from 'classnames';
import Icon, {ICONS} from './Icon';

class ToggleValueIndicator extends React.PureComponent {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        this.props.onClick(this.props.path, !this.props.value);
    }

    render() {
        const {value} = this.props;
        return (
            <Icon className={classNames('ms-1', {'text-primary': value})} icon={value ? ICONS.TOGGLE_ON : ICONS.TOGGLE_OFF} onClick={this.handleClick} />
        );
    }
}

export default ToggleValueIndicator;
